<template>
  <div class="analyze-data">
    <div class="page-title-bi">
      <PageTitle
        isBack="true"
        link="home"
        fontSize="25"
        icon="fa fa-line-chart"
        title="Analise de Dados"
      />
    </div>
    <div class="screen-bi">
      <vs-card actionable class="cardx card-bi" v-for="screenBi in screenBiData" :key="screenBi.id">
        <div slot="header">
          <h3>{{screenBi.name}}</h3>
        </div>
        <div slot="media">
          <img
            v-if="screenBi.imageBase64"
            v-bind:src="`data:image/jpeg;base64, ${screenBi.imageBase64}`"
            @click="clickImage(screenBi.url)"
          >
          <img
            v-else
            height="168"
            src="https://smedia2.intoday.in/btmt/images/stories/data-analytics_660_120717022837.jpg"
          >
        </div>
        <div class="card-message">
          <span>{{screenBi.description}}</span>
        </div>
        <div slot="footer">
          <vs-row vs-justify="flex-end">
            <vs-button color="primary" type="gradient" @click="viewBI(screenBi.url)">Visualizar</vs-button>
          </vs-row>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
//compoenents
import PageTitle from "@/components/template/PageTitle";
//variaveis globais
import { baseApiUrl } from "@/global";
//cliente http
import axios from "axios";

export default {
  name: "BI",
  components: { PageTitle },
  data() {
    return {
      userContext: this.$store.state.userContext,
      screenBiData: []
    };
  },
  methods: {
    listScreenBi() {
      axios
        .get(`${baseApiUrl}/bi/listScreen/${this.userContext.userId}`)
        .then(resp => {
          this.screenBiData = resp.data;
        });
    },
    clickImage(url) {
      this.viewBI(url);
    },
    viewBI(url) {
      window.open(`${url}`, "_blank");
    }
  },
  mounted() {
    this.listScreenBi();
  }
};
</script>

<style scoped>
.page-title-bi {
  margin-top: 2px;
  margin-bottom: 2%;
  text-align: center;
}

.screen-bi {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.card-bi {
  max-width: 300px;
  margin: 13px;
}

.card-content {
  max-height: 80px;
}

.card-bi span {
  font-size: 18px;
}

.card-message {
  height: 90px;
}
</style>
